
import axios from "axios";
import rutas from '@/assets/utils/rutas.json';


const getAll = async ( params = {} ) => {
  const {
    search, tokenLaboratorio, 
    fechaDesde, fechaHasta, establecimiento,
    page, pageSize, excel, estadoLaboratorio, 
    especialidad, cobertura, idPaciente, tipoFecha,
    observaciones
  } = params;

  const query = `
    query AllLaboratoriosAux(
      $search             : String
      $tokenLaboratorio   : String
      $establecimiento    : String
      $idPaciente         : String
      $fechaDesde         : String
      $fechaHasta         : String
      $page               : Int
      $pageSize           : Int
      $excel              : String
      $estadoLaboratorio  : String 
      $especialidad       : String 
      $cobertura          : String 
      $tipoFecha          : String 
      $observaciones      : String 
    ) {
      allLaboratoriosAux(
        search            : $search
        tokenLaboratorio  : $tokenLaboratorio
        establecimiento   : $establecimiento
        idPaciente        : $idPaciente
        fechaDesde        : $fechaDesde
        fechaHasta        : $fechaHasta
        page              : $page
        pageSize          : $pageSize
        excel             : $excel
        estadoLaboratorio : $estadoLaboratorio
        especialidad      : $especialidad
        cobertura         : $cobertura
        tipoFecha         : $tipoFecha
        observaciones     : $observaciones
      ) {
        total
        status
        message
        labFile
        laboratorios {          
          id
          token
          estadoHomologado
          estadoLaboratorio
          fechaProgramada
          fechaResultado: fechaResultados
          fechaCreacion
          ultimoCambio
          codigoOrden
          codigoOrion
          laboratorios
          urlInforme
          urlMspCalificacion
          urlMspCalificacion1
          urlMspCalificacion2
          atencionMedica {
            id
            token
            cita {
              id
              urlsMspPaciente
              urlsMspTitular1
              urlsMspTitular2
              urlsMspTitular3
              detallescitaSet {
                id
                detailsSeguro
                detallesTitulares
              }
              cobSeleccionada{
                id
                descripcion
              }
              fechaCita
              fechaCreacion
              establecimiento {
                id
                Descripcion
              }
              doctor {
                idPersona {
                  primerApellido
                  primerNombre
                }
                especialidad {
                  id
                  descripcion
                }
              }
              paciente {
                id
                persona {
                  identificacion
                  primerApellido
                  primerNombre
                  telefono
                  correo
                }
              }
            }
          }

          
        }
      }
    }
  `;

  const variables = {
    search,
    tokenLaboratorio, 
    fechaDesde, 
    fechaHasta,
    establecimiento,
    idPaciente,
    page,
    pageSize,
    excel,
    estadoLaboratorio,
    especialidad,
    cobertura,
    tipoFecha,
    observaciones
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;
    const response2 = response.data.data.allLaboratoriosAux;
    if( response2.status !== 'success' ) return null;
    
    return {
      total: response2.total,
      data: response2.laboratorios,
      labFile: response2.labFile
    };

  }catch(error){
    console.error('Error al obtener laboratorios auxiliares', error);
    return error;
  }
}



const getByAtencion = async ( tokenAtencion ) => {

  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllLaboratoriosAux($tokenAtencion: String) {
      allLaboratoriosAux(tokenAtencion: $tokenAtencion) {
        status
        message
        total
        laboratorios {
          id
          token
          laboratorios 
          urlInforme
          atencionMedica {
            id
            token
          }
          codigoOrden
          justificacion
          estadoHomologado
          estadoLaboratorio
          estado
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allLaboratoriosAux;
    if( response2.status !== 'success' ) return null;

    const data = response2.laboratorios;
    return data;

  }catch( error ){
    console.error( error );
    return error;
  }
}



const create = async ( estudioLab, fields ) => {

  const query = `
    mutation CrearLabAuxiliar(
      $estudioLab    : String!
      $laboratorio : String!
      $homologado    : String
    ) {
      crearLabAuxiliar(
        estudioLab    : $estudioLab, 
        idLaboratorio : $laboratorio
        homologado    : $homologado, 
      ) {
        message
        status
        labAuxiliar {
          id
          token
        }
      }
    }
  `;

  const variables = {
    ...fields,
    estudioLab
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    
    return response;
  }catch( error ){
    console.error( error );
    return error;
  }
}


const sendOrion = async (tokenLaboratori) => {
  const query = `
    query sendorionaux(
      $tokenLaboratorio: String!
    ) {
      sendorionaux(
        tokeni: $tokenLaboratorio
      ) {
        json
        message
        status
      }
    }
  `;
  const variables = {
    tokenLaboratorio: tokenLaboratori.token
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if (response.status !== 200) return null;

    const data = response.data.data.sendorionaux;
    const parsedJson = data.json ? JSON.parse(data.json) : null;

    return {
      json: parsedJson,
      message: data.message,
      status: data.status,
    };
  } catch (error) {
    console.error('Error al enviar orden a Orion', error);
    return null;
  }
};



const updateByToken = async (tokenLaboratorio, fieldsToUpdate) => {

  const query = `
    mutation UpdateLabAuxiliar(
      $tokenLaboratorio    : String!
      $codigoOrion         : String
      $fechaProgramada     : String
      $urlMspCalificacion  : String
      $urlMspCalificacion1 : String
      $urlMspCalificacion2 : String
      $auxiliarMuestras    : String
      $estadoLaboratorio   : String
      $fechaResultado      : DateTime
      $urlInforme          : String
    ) {
      updateLabAuxiliar(
        tokenLaboratorio    : $tokenLaboratorio,
        fechaProgramada     : $fechaProgramada,
        urlMspCalificacion  : $urlMspCalificacion,
        urlMspCalificacion1 : $urlMspCalificacion1,
        urlMspCalificacion2 : $urlMspCalificacion2,
        auxiliarMuestras    : $auxiliarMuestras,
        codigoOrion         : $codigoOrion,
        estadoLaboratorio   : $estadoLaboratorio,
        fechaResultado      : $fechaResultado,
        urlInforme          : $urlInforme
      ) {
        message
        status
        labAuxiliar {
          id
          token
          estadoLaboratorio
          fechaResultado: fechaResultados
          urlInforme
        }
      }
    }
  `;

  const variables = {
    tokenLaboratorio,
    ...fieldsToUpdate
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.updateLabAuxiliar;
    if(response2.labAuxiliar == null) return response2;
    const data = response2.labAuxiliar;
    return data;

  }catch(error){
    console.error('Error al actualizar lab auxiliar', error);
    return null;
  }
}


const saveLaboratorios = async (dataLab) => {

  // ejemplo de objeto que debe ser dataLab
  // {
  //   accion       : 'registrado',
  //   idRegistro   : lab.id,
  //   codigoOrden  : lab.codigoOrden,
  //   laboratorio,
  //   justificacion: lab.justificacion,
  //   esHomologado : lab.estadoHomologado, ya se envia en la peticion
  // }

  if(!dataLab) return null;

  const query = `
    mutation SaveLaboratoriosAuxiliares(
      $dataLaboratorios: [LaboratorioAuxiliarInput!]!
    ) {
    saveLaboratoriosAuxiliares(
      dataLaboratorios: $dataLaboratorios
    ) {
        message
        status
        labAuxiliar
      }
    }
  `;

  const variables = {
    dataLaboratorios: dataLab
  }

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });

    if(response.status !== 200) return null;

    const response2 = response.data.data.saveLaboratoriosAuxiliares;
    if( response2.status !== 'success' ) return null;

    const data = response2.labAuxiliar;
    return data;

  }catch(error){
    console.error('Error al guardar laboratorios auxiliares', error);
    return null;
  }
}


export const labAuxiliarService = {
  saveLaboratorios,
  getAll,
  getByAtencion,
  create,
  updateByToken,
  sendOrion
}
